import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    grupoItem: [],
    fakeID: 4,
  },
  mutations: {
    carregarGrupoItem(state, grupos) {
      state.grupoItem = grupos;
    },
    gravarGrupoItem(state) {
      state.fakeID++;
    },
    buscarGrupoItem(state, response) {
      state.grupoItem = response;
    },
  },
  actions: {
    async listar({ commit }) {
      try {
        const response = await securedAxios.get("grupoitem");
        commit("carregarGrupoItem", response.data);
        return Promise.resolve(true);
      } catch (err) {
        commit("carregarGrupoItem", []);
        return Promise.reject(err);
      }
    },
    async buscar(context, aFiltro) {
      try {
        var filtro = aFiltro.filtro ? aFiltro.filtro : "";
        var valor = aFiltro.valor ? aFiltro.valor : "";

        await securedAxios
          .get("grupoitem?" + filtro + "=" + valor)
          .then((response) => context.commit("buscarGrupoItem", response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravar(context, GrupoItemInfo) {
      try {
        var id = GrupoItemInfo.id;

        if (id == "") {
          var infoNovo = {
            id: this.state.fakeID,
            descricao: GrupoItemInfo.descricao,
            codigo: GrupoItemInfo.codigo,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true,
            },
          };
          await securedAxios.post("grupoitem", infoNovo);
          context.commit("gravarGrupoItem");
        } else {
          var infoAltera = {
            descricao: GrupoItemInfo.descricao,
            codigo: GrupoItemInfo.codigo,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true,
            },
          };
          await securedAxios.put("grupoitem/" + id, infoAltera);
          context.commit("gravarGrupoItem");
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletar(context, id) {
      try {
        await securedAxios.delete("grupoitem/" + id.id);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarGrupoItem(context, id) {
      try {
        const response = await securedAxios.get("grupoitem/" + id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
